<template>
    <div class="elem-map-box">
        <elem-input-object :name="name" :title="title" :required="required" :getValue="getValue"></elem-input-object>
        <div class="map-input-box">
            <input class="input" v-model="input_value" type="text" placeholder="输入地址" @input="onInput" @focus="onFocus" @blur="onBlur" />
            <div class="result-box" v-show="display_result && result && result.length > 0">
                <div class="item-box" v-for="(item, idx) in result" :key="idx" @mousedown="onSelectResult(item)">
                    <p class="name">{{ item.name }}</p>
                    <p class="district">{{ item.district }}</p>
                </div>
            </div>
        </div>
        <div class="map-container-box" :id="id"></div>
    </div>
</template>

<script lang="ts">
import Utils from "@/module/utils/utils"
import elemInputObject from "./elem-input-object.vue"
import FileUtil from "@/module/file/file_util"
import Message from "@/module/interactive/message"

export default {
    data() {
        return {
            input_value: "",
            init_marker: false,
            display_result: false,
            result: null,
            old_value: null,
            id: Utils.getUuid(),
        }
    },

    props: {
        name: String,
        required: {
            type: Boolean,
            default: true,
        },
        title: String,
        value: Object,
    },

    components: {
        elemInputObject,
    },

    async created() {
        if (this.value) {
            this.old_value = Utils.copy(this.value)
        }
    },

    async mounted() {
        // 加载主文件
        if (!window["AMapLoader"]) {
            await FileUtil.script("https://webapi.amap.com/loader.js")
        }

        const AMap = await window["AMapLoader"].load({
            key: "fd71e18f00affc42b5711435dd44064b", //首次调用load必须填写key
            version: "2.0", //JSAPI 版本号
            plugins: ["AMap.Scale", "AMap.Geolocation", "AMap.Geocoder", "AMap.AutoComplete"], //同步加载的插件列表
        })

        const map = (this.map = new AMap.Map(this.id))
        map.addControl(new AMap.Scale())
        map.addControl(new AMap.Geolocation())

        this.geocoder = new AMap.Geocoder()

        // 实例化输入提示模块
        this.autoComplete = new AMap.AutoComplete()

        // 实例化标记
        this.marker = new AMap.Marker({
            icon: new AMap.Icon({
                size: new AMap.Size(40, 40), // 图标大小
                image: "/admin/static/icon/location.png",
            }),
            offset: new AMap.Pixel(-18, -38), // 偏移
            draggable: true, //点标记可拖拽
        })

        map.on("click", this.onClickMarker) //绑定click事件

        if (this.old_value) {
            this.init(this.old_value)
        }
    },

    deactivated() {
        this.map.destroy()
    },

    methods: {
        init(data) {
            let { latitude, longitude } = data
            let lnglat = [longitude, latitude]

            this.setMarkerPosition(lnglat)
            this.map.setZoom(15)
            this.map.setCenter(lnglat)

            this.input_value = data.address
        },

        onClickMarker(evt) {
            var lnglat = (this.lnglat = [evt.lnglat.lng, evt.lnglat.lat])

            this.setMarkerPosition(lnglat)

            if (this.input_value) return

            this.geocoder.getAddress(lnglat, (status, result) => {
                if (status === "complete" && result.info === "OK") {
                    this.input_value = result.regeocode.formattedAddress
                } else {
                    Message.error(result.info)
                }
            })
        },

        setMarkerPosition(lnglat) {
            if (!this.init_marker) {
                this.map.add(this.marker)
                this.init_marker = true
            }

            this.marker.setPosition(lnglat)
        },

        /**
         * 监听文本框输入事件
         */
        onInput(evt) {
            // 清除延时事件
            clearTimeout(this.inputTimeout)

            // 延时执行
            this.inputTimeout = setTimeout(() => {
                const e = Utils.getTarget<HTMLInputElement>(evt)

                if (e.value) {
                    // 根据关键字进行搜索
                    this.autoComplete.search(e.value, (status, result) => {
                        // 搜索成功时，result即是对应的匹配数据
                        if (status === "complete" && result.info === "OK") {
                            this.result = result.tips
                            this.display_result = true
                        } else if (status !== "no_data") {
                            Message.error(result.info)
                        }
                    })
                } else {
                    this.result = null
                }
            }, 1000)
        },

        /**
         * 监听选择搜索结果
         */
        onSelectResult(evt) {
            var lnglat = (this.lnglat = [evt.location.lng, evt.location.lat])

            this.setMarkerPosition(lnglat)
            this.map.setZoom(15)
            this.map.setCenter(lnglat)

            this.input_value = [evt.district, evt.name].filter((v) => v && v.length > 0).join("")
        },

        getValue() {
            return new Promise((resolve) => {
                const value = this.input_value

                if (!value) {
                    return resolve(null)
                }

                var data

                if (!this.lnglat) {
                    data = this.getLocation(value)
                } else {
                    data = this.getAddress(this.lnglat)
                }

                console.log(data);
                

                data.then(resolve)
            })
        },

        /**
         * 地址转为坐标
         */
        getLocation(value) {
            return new Promise((resolve) => {
                this.geocoder.getLocation(value, (status, result) => {
                    if (status === "complete" && result.info === "OK" && result.geocodes.length > 0) {
                        // 返回第一条数据
                        let data = result.geocodes[0]
                        let l = data.location

                        resolve({
                            adcode: data.adcode,
                            city: data.addressComponent?.city,
                            district: data.addressComponent?.district,
                            province: data.addressComponent?.province,
                            street: data.addressComponent?.street,
                            address: this.input_value || data.formatted_address,
                            longitude: l.lng,
                            latitude: l.lat,
                        })
                    } else {
                        let msg = "无法识别输入的地址，请在地图上选址！"
                        // 显示错误信息
                        Message.error(msg)
                    }
                })
            })
        },

        /**
         * 坐标转为地址
         */
        getAddress(lnglat) {
            return new Promise((resolve) => {
                this.geocoder.getAddress(lnglat, (status, result) => {
                    if (status === "complete" && result.info === "OK") {
                        let data = result.regeocode
                        let a = data.addressComponent
                        let f = data.formattedAddress

                        // 返回第一条数据
                        resolve({
                            adcode: a.adcode,
                            city: a.city,
                            country: a.country,
                            district: a.district,
                            province: a.province,
                            address: this.input_value || f,
                            longitude: lnglat[0],
                            latitude: lnglat[1],
                        })
                    } else {
                        let msg = "无法识别经纬度，请在地图上选址！"
                        // 显示错误信息
                        Message.error(msg)
                    }
                })
            })
        },

        onFocus() {
            setTimeout(() => {
                this.display_result = true
            }, 100)
        },

        onBlur() {
            setTimeout(() => {
                this.display_result = false
            }, 100)
        },
    },
}
</script>

<style>
.elem-map-box {
    position: relative;
    height: 250px;
}

.elem-map-box .map-input-box {
    position: absolute;
    top: 20px;
    left: 20px;
    right: 20px;
    border: 1px solid #e3e4e9;
    background: #fff;
    border-radius: 6px;
    transition: all 0.3s ease;
    overflow: hidden;
    box-sizing: border-box;
    z-index: 10;
}

.elem-map-box .input {
    width: 100%;
    padding: 0 12px;
    height: 40px;
    color: #000;
    box-sizing: border-box;
}

.elem-map-box .result-box {
    width: 100%;
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    border-top: 1px solid #e3e4e9;
}

.elem-map-box .result-box > .item-box {
    cursor: pointer;
    padding: 10px 12px;
    border-bottom: 1px solid #e3e4e9;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.elem-map-box .result-box > .item-box:last-child {
    border-bottom: initial;
}

.elem-map-box .result-box > .item-box:hover {
    background: #f3f3f3;
}

.elem-map-box .result-box > .item-box .name {
    font-size: 14px;
    color: #000;
}

.elem-map-box .result-box > .item-box .district {
    font-size: 12px;
    color: #888;
}

.elem-map-box .map-container-box {
    width: 100%;
    height: 100%;
}

.elem-map-box .map-container-box {
    border: 1px solid #e3e4e9;
    z-index: 5;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.elem-map-box .map-container-box:hover {
    border-color: #b3b3b3;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
